import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	frame: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '48px',
		height: '48px',
	},
	avatar: {
		flexShrink: 0,
		width: '96px',
		height: '96px',
		transform: 'scale(0.7)',
		transformOrigin: 'center',
	},
});

// Keep the scaled 96px ADS avatar centered in the card's 48px layout frame.
export const CardAvatarFrame = ({ children }: { children: React.ReactNode }): React.JSX.Element => (
	<Box xcss={styles.frame}>
		<Box xcss={styles.avatar}>{children}</Box>
	</Box>
);
